import React from 'react'
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";


const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'This contemporary garden was designed for a young family looking to take full advantage of a generous plot of land previously dominated by a pool. The old pool was reworked into a new lawn area and a more considered design connects the rear of the home to the outdoor areas.',
            'Providing all weather shelter the cabana was constructed with louvered walls allowing natural breeze to flow during the summer months and heat to be retained when cool. Adjustable louvers also allow the tennis court to be viewed when in use. Built in bench seating provides a casual retreat where the whole garden can be viewed from, while lighting, heating and wireless audio allow the space to be enjoyed into the evenings.',
            'Frameless glass fencing secures the inviting sky blue pool which is heated by both gas and solar providing year round enjoyment. Strategic screen planting will ensure the garden becomes a private oasis and allow the many layers of tropical plants to thrive in the hot summer conditions.',
        ],
        descriptionContent : (
          <p>
          <span className="line">
          <b>Services Undertaken</b>
          <br />Landscape Design
          <br />Construction
          <br />Ongoing Maintenance
          <br />Application to Council
          <br />Structural Engineering
          </span>
          
          <b>Design Features</b>
          <br />Contemporary
          <br />Family
          <br />Entertainer
          <br />Pool
          </p>
        ),
        image : '../images/projects/castle-hill-2.jpg',
        title : 'Castle Hill'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/castle-hill-1.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/castle-hill-2.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/castle-hill-3.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/castle-hill-4.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/castle-hill-5.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/castle-hill-6.jpg'
    },
]

const PageCastleHill = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
}

export default PageCastleHill